import React from 'react';
import { ForgotPasswordForm } from '@features/auth/components/forgot-password/ForgotPasswordForm';

import { W2AuthChrome } from './W2AuthChrome';
import { useW2Paths } from './paths';

/** Forgot-password screen under `/e/*` — kills the old in-form stranding bug by
 *  giving the "forgot" affordance a real sibling route. */
export const W2ForgotRoute: React.FC = () => {
  const paths = useW2Paths();
  return (
    <W2AuthChrome>
      <ForgotPasswordForm loginPath={paths.login} />
    </W2AuthChrome>
  );
};
